import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "decimalToPercentage",
    standalone: false
})
export class DecimalToPercentagePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (typeof value !== "number") return value;

    const percentage = value * 100;
    return `${percentage.toFixed(args[0] ? args[0] : 0)}%`;
  }
}
